import {
  AUTH_REQUEST,
  AUTH_ERROR,
  AUTH_SUCCESS,
  AUTH_LOGOUT,
  AUTH_RESET,
  AUTH_REGISTER,
  AUTH_REQUEST_REFRESH_TOKEN,
  AUTH_REQUEST_IFRAME,
} from "../actions/auth";
import {
  USER_CRM_REQUEST,
  USER_CRM_LICENCE_STATUS_REQUEST,
  USER_CRM_LICENCE_STATUS_REQUIRED,
  USER_CRM_RELOAD,
} from "@/store/actions/user";
import { SNACKBAR_CLOSE_ALL } from "@/store/actions/snackbar";
import { IFRAME_LOADING } from "@/store/actions/navigation";
import api from "@/utils/api";
import cookie from "@/utils/cookie";
import store from "..";
import restrictions from "../../utils/restrictions";
const axios = require("axios");

export const getDefaultState = () => ({
  access_token: cookie.getCookie("user-token") || "",
  refresh_token: cookie.getCookie("refresh-token") || "",
  status: "",
  hasLoadedOnce: false,
});
const state = getDefaultState();

const getters = {
  isAuthenticated: (state) => !!state.access_token,
  getAccessToken: (state) => state.access_token,
  authStatus: (state) => state.status,
};

const actions = {
  [AUTH_REQUEST]: ({ commit, dispatch }, { username, password }) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST);

      let postData = `grant_type=password&client_id=${
        store.getters.getClientIDs.clientId
      }&client_secret=${
        store.getters.getClientIDs.clientSecret
      }&username=${encodeURIComponent(username)}&password=${encodeURIComponent(
        password
      )}`;

      axios
        .post(
          process.env.VUE_APP_BASE_API_URL + "oauth2/access_token",
          postData
        )
        .then((resp) => {
          cookie.setCookie("user-token", resp.data.access_token, 30);
          cookie.setCookie("refresh-token", resp.data.refresh_token, 30);
          api.service.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${resp.data.access_token}`;
          commit(AUTH_SUCCESS, resp);
          dispatch(USER_CRM_RELOAD)
            .then((resp) => {
              resolve(resp);
            })
            .catch((err) => {
              console.error(err);
            });
        })
        .catch((err) => {
          commit(AUTH_ERROR, err);
          cookie.deleteCookie("user-token");
          cookie.deleteCookie("refresh-token");
          console.error(err);
          reject(err);
        });
    });
  },
  [AUTH_REQUEST_REFRESH_TOKEN]: ({ commit, dispatch, state }) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST);
      api
        .oauth2RefreshToken({
          refresh_token:
            state.refresh_token !== ""
              ? state.refresh_token
              : cookie.getCookie("refresh-token"),
        })
        .then((resp) => {
          cookie.setCookie("user-token", resp.data.access_token, 30);
          cookie.setCookie("refresh-token", resp.data.refresh_token, 30);
          api.service.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${resp.data.access_token}`;

          commit(AUTH_SUCCESS, resp);
          dispatch(USER_CRM_REQUEST).then((resp) => {
            resolve(resp);
          });
        })
        .catch((err) => {
          console.error({
            date: JSON.stringify(new Date()),
            ust: cookie.getCookie("user-token"),
            refreshT: cookie.getCookie("refresh-token"),
            err: JSON.stringify(err.response.data),
            user: JSON.stringify(store.getters.getMe),
          });
          commit(AUTH_ERROR, err);
          cookie.deleteCookie("user-token");
          cookie.deleteCookie("refresh-token");
          reject(err);
        });
    });
  },
  [AUTH_REQUEST_IFRAME]: ({ commit, dispatch }, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(process.env.VUE_APP_BASE_API_URL + "crm/jwt-login/", {
          token: data,
        })
        .then((resp) => {
          cookie.setCookie("user-token", resp.data.access_token, 30);
          cookie.setCookie("refresh-token", resp.data.refresh_token, 30);
          api.service.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${resp.data.access_token}`;
          commit(AUTH_SUCCESS, resp);
          dispatch(USER_CRM_REQUEST).then((resp) => {
            commit(IFRAME_LOADING, false);
            resolve(resp);
          });
        })
        .catch((err) => {
          commit(IFRAME_LOADING, true);
          commit(AUTH_ERROR, err);
          cookie.deleteCookie("user-token");
          cookie.deleteCookie("refresh-token");
          reject(err);
        });
    });
  },
  [AUTH_LOGOUT]: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      api.expireUserToken().finally(() => {
        commit(AUTH_LOGOUT);
        commit(SNACKBAR_CLOSE_ALL);
        cookie.deleteCookie("user-token");
        cookie.deleteCookie("refresh-token");
        delete api.service.defaults.headers.common["Authorization"];
        resolve();
      });
    });
  },
  [AUTH_RESET]: ({ commit, dispatch }, email) => {
    return new Promise((resolve, reject) => {
      api
        .requestPasswordReset(email)
        .then((resp) => {
          resolve("success");
        })
        .catch((err) => {
          resolve("error");
        });
    });
  },
  [AUTH_REGISTER]: ({ commit, dispatch }, credentials) => {
    return new Promise((resolve, reject) => {
      api
        .register(credentials, credentials.uuid)
        .then((resp) => {
          dispatch(AUTH_REQUEST, {
            username: credentials.email,
            password: credentials.password,
          }).then((resp) => {
            dispatch(USER_CRM_REQUEST).then(() => {
              resolve();
            });
          });
        })
        .catch((err) => {});
    });
  },
};

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.status = "loading";
  },
  [AUTH_SUCCESS]: (state, resp) => {
    state.status = "success";
    state.access_token = resp.data.access_token;
    state.refresh_token = resp.data.refresh_token;
    state.hasLoadedOnce = true;
  },
  [AUTH_ERROR]: (state) => {
    state.status = "error";
    state.hasLoadedOnce = true;
  },
  [AUTH_LOGOUT]: (state) => {
    Object.assign(state, getDefaultState());
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
